import { GetterTree } from 'vuex';
import { addSeconds, format } from 'date-fns';

export const getters: GetterTree<any, any> = {
  playerTimes(state) {
    let timeLeft = state.player.duration - state.player.currentTime;
    if (isNaN(timeLeft)) {
      timeLeft = 0.0;
    }
    return {
      percentComplete: state.player.percentComplete,
      currentTime: state.player.currentTime,
      currentTimeFormatted: format(
        addSeconds(new Date(0), Math.floor(state.player.currentTime) || 0),
        'mm:ss',
      ),
      duration: state.player.duration,
      timeLeft,
      timeLeftFormatted: format(
        addSeconds(new Date(0), Math.ceil(timeLeft)),
        'mm:ss',
      ),
    };
  },
  playlistHasNextSong(state) {
    return (
      state.player.isPlaylistPlaying &&
      state.player.playlistIndex < state.player.playlistSongs.length - 1
    );
  },
  playlistHasPrevSong(state) {
    return state.player.isPlaylistPlaying && state.player.playlistIndex > 0;
  },
};

export default getters;
